import BasePage from "pages/base_page"

import SignupProcess from "views/signup_process"

export default class NewRegistrationPage extends BasePage {
  initialize(options) {
    super.initialize(options)

    return (this.signup = new SignupProcess())
  }
}
